import React, { useEffect, useState } from "react";
import { Trans, useTranslation } from "react-i18next";

// Assets
import "~/assets/sass/pages/mypage/signature/signature.scss";

const SignaturePolicyModal = ({ setSignatureUploadModal, setDigitalDataModalModal }) => {
	const { t } = useTranslation();
	const [isCheckAll, setIsCheckAll] = useState(false);
	const [policyList, setPolicyList] = useState([
		{
			id: 1,
			text: (
				<>
					<Trans
						i18nKey={"pages.myPage.SignaturePage.SignaturePolicyModal.idx1"}
						components={[<b></b>]}
					/>
				</>
			),
			checked: false,
		},
		{
			id: 2,
			text: (
				<>
					<Trans
						i18nKey={"pages.myPage.SignaturePage.SignaturePolicyModal.idx2"}
						components={[<b></b>]}
					/>
				</>
			),
			checked: false,
		},
		{
			id: 3,
			text: (
				<>
					<Trans
						i18nKey={"pages.myPage.SignaturePage.SignaturePolicyModal.idx3"}
						components={[<b></b>]}
					/>
				</>
			),
			checked: false,
		},
		{
			id: 4,
			text: (
				<>
					<Trans
						i18nKey={"pages.myPage.SignaturePage.SignaturePolicyModal.idx4"}
						components={[<b></b>]}
					/>
				</>
			),
			checked: false,
		},
	]);

	// 전체 선택

	// checkIsAll 의 값을 바꿔줘 모든 항목들을 Check 할 함수

	// policyList 의 값들을 주시하고 있다가 check 가 하나라도 풀리면 allCheck를 푸는 useEffect

	useEffect(() => {
		let doCheckAll = policyList.find((p) => p.checked === false);
		if (doCheckAll) {
			setIsCheckAll(false);
		} else {
			setIsCheckAll(true);
		}
	}, [policyList]);

	const handleCheckAll = () => {
		const value = policyList.map((v) => ({
			...v,
			checked: !isCheckAll,
		}));

		setIsCheckAll(!isCheckAll);
		setPolicyList(value);
	};

	return (
		<>
			<div className="modal-content signature-policy">
				<div className="checkbox check-all">
					<label className="checkbox-custom">
						<input type="checkbox" checked={isCheckAll} onChange={handleCheckAll} />
						<span className="checkmark" />
						<span className="checkbox-label">
							{t("pages.myPage.SignaturePage.SignaturePolicyModal.checkboxLabel")}
						</span>
					</label>
				</div>

				{policyList.map((p) => {
					return (
						<div className="checkbox" key={p.id}>
							<label className="checkbox-custom">
								<input
									type="checkbox"
									checked={p.checked}
									onChange={() => {
										const newValue = policyList.map((policy) =>
											p.id === policy.id
												? { ...policy, checked: !p.checked }
												: policy
										);
										setPolicyList(newValue);
									}}
								/>
								<span className="checkmark" />
								<span className="checkbox-label">{p.text}</span>
							</label>
						</div>
					);
				})}
			</div>
			<div className="modal-footer">
				<button type="button" className="btn__solid" color="gray">
					{t("common.commonWord.button.cancel")}
				</button>
				<button
					type="button"
					className="btn__solid"
					color="primary"
					onClick={() => {
						setSignatureUploadModal(true);
						setDigitalDataModalModal(false);
					}}
					disabled={!isCheckAll}
				>
					{t("common.commonWord.button.next")}
				</button>
			</div>
		</>
	);
};

export default SignaturePolicyModal;
